import Page from './Page.js';

/**
 * Class Blog
 */
class Blog extends Page {


  /**
   * Constructor
   */
  constructor(currentPageId){
    super();
    // Properties
    this.currentPageId = currentPageId;
    this.content = {};
  }


  /**
   * Init
   */
  init() {
  }


  /**
   * Set events listeners
   */
  setEventsListeners() {

  }


  /**
   * Unset events listeners
   */
  unsetEventsListeners() {

  }

  resizeSlider() {

  }


  /**
   * Go
   */
  go(){
    this.getPageContent();
  }


  /**
   * Get page content
   */
  getPageContent() {
    console.log("get page content");
    window.location.href = '/blog';
    /*
    this.ajax("wp-json/wp/v2/posts").then(
      function(result) {
        var data = JSON.parse(result);
        this.content = data[0].acf;
        this.content.blog_request_form = data[0].content.rendered
          .replace(/action\=\"([\s\S]*?)\"/i, 'action="/blog"');
        // getaway
        this.display();
      }.bind(this)
    ).catch(function(msg) {
      console.log(msg);
    });
    */

  }

  /**
   * Display
   */
  display() {
    console.log("display");

    // set page meta
    document.getElementById(this.currentPageId).setAttribute("id", "blog-page-container");
    this.currentPageId = "blog-page-container";

    // Send built event
    var e = document.createEvent("CustomEvent");
    e.initCustomEvent('page_built', false, false, {
      'slug': '/blog',
      'template': template
    });
    window.dispatchEvent(e);
  }

}

export default Blog;


